import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container, Button } from "react-bootstrap";
import {
  getLevel5LedgerData,
  searchAccountLedger,
  searchAccountLedgerReport,
} from "./Ledger.action";
import { connect } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import "./style.css";
import { isEmpty, get } from "lodash";
import Select from "react-select";
import { Redirect, Link } from "react-router-dom";
import { startFinancialDate } from "../../../../global/globalFunctions";
import moment from "moment";

const AccountLedger = (props) => {
  const [show, setShow] = useState(false);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [item, setItem] = useState("");
  const [itemName, setItemName] = useState("");

  const getLevel5LedgerData1 = props.level5LedgerData.map((x) => {
    let data = {
      value: x.levelFiveId,
      label: x.allLevelKey + " " + x.levelFiveName,
    };
    return data;
  });
  const handleChangeLevel5Ledger = (selectedOption) => {
    setItem(selectedOption.value);
    setItemName(selectedOption.label);
  };

  const exportPDF = () => {
    props.searchAccountLedgerReport(
      {
        startedDate: !isEmpty(startDate) ? startDate : "",
        endDate: !isEmpty(endDate) ? endDate : "",
        levelFiveId: item,
        name: itemName,
      },
      startDate,
      endDate
    );
  };

  useEffect(() => {
    props.getLevel5LedgerData();
  }, []);

  function searchData() {
    props.searchAccountLedger({
      startedDate: !isEmpty(startDate) ? startDate : "",
      endDate: !isEmpty(endDate) ? endDate : "",
      levelFiveId: item,
      name: itemName,
    });
    return (
      <Redirect
        to={{ pathName: "/user/Ledger-List", state: { name: itemName } }}
      />
    );
  }

  return (
    <>
      {props.isFetchingLevel5LedgerData ? (
        <div className="loader-div">
          <Button variant="info" disabled>
            <Spinner
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
              variant="info"
            />
            {props.isFetchingLevel5LedgerData ? "Loading..." : "Loading..."}
          </Button>
        </div>
      ) : (
        <Container fluid>
          <div className="main">
            <Row>
              <Col lg="4" md="12" sm="12">
                <Form.Group>
                  <Form.Label>
                    <b> Start Date </b>
                  </Form.Label>
                  <Form.Control
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  ></Form.Control>
                </Form.Group>
              </Col>
              <Col lg="4" md="12" sm="12">
                <Form.Group>
                  <Form.Label>
                    <b> End Date</b>
                  </Form.Label>
                  <Form.Control
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  ></Form.Control>
                </Form.Group>
              </Col>
              <Col lg="4" md="12" sm="12">
                <Form.Group>
                  <Form.Label>
                    <b> Select Account *</b>
                  </Form.Label>
                  <Select
                    placeholder="Select Account..."
                    onChange={handleChangeLevel5Ledger}
                    options={getLevel5LedgerData1}
                  />
                </Form.Group>
              </Col>
            </Row>

            {props.isFetchingSearchAccountLedgerReport ? (
              <div className="loader-div">
                <Button variant="info" disabled>
                  <Spinner
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    variant="info"
                  />
                  {props.isFetchingSearchAccountLedgerReport
                    ? "Loading..."
                    : "Loading..."}
                </Button>
              </div>
            ) : (
              <Row style={{marginTop:'15px'}}>
                <Col lg="12" sm="12" className="text-center">
                  {item == "" ? (
                    <Button
                      disabled
                      style={{ backgroundColor: "black" }}
                      className="sendButton"
                    >
                      Search
                    </Button>
                  ) : (
                    <Link
                      to={{
                        pathname: "/user/Ledger-List",
                        state: { start: startDate, end: endDate },
                      }}
                    >
                      <Button
                        className="sendButton"
                        onClick={(e) => searchData()}
                      >
                        Search
                      </Button>
                    </Link>
                  )}
                </Col>

                <div className="sendDiv">
                  {item == "" ? (
                    <Button
                      disabled
                      style={{ backgroundColor: "black" }}
                      className="sendButton"
                    >
                      Generate Ledger Report
                    </Button>
                  ) : (
                    <Button className="sendButton" onClick={() => exportPDF()}>
                      Generate Ledger Report
                    </Button>
                  )}
                </div>
              </Row>
            )}
          </div>
        </Container>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getLevel5LedgerData: () => dispatch(getLevel5LedgerData()),
    searchAccountLedger: (data) => dispatch(searchAccountLedger(data)),
    searchAccountLedgerReport: (data, startDate, endDate) =>
      dispatch(searchAccountLedgerReport(data, startDate, endDate)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  level5LedgerData: state.AccountLegderReducer.level5LedgerData,
  searchAccountLedgerList: state.AccountLegderReducer.searchAccountLedgerList,
  isFetchingLevel5LedgerData:
    state.AccountLegderReducer.isFetchingLevel5LedgerData,
  isFetchingSearchAccountLedger:
    state.AccountLegderReducer.isFetchingSearchAccountLedger,
  isFetchingSearchAccountLedgerReport:
    state.AccountLegderReducer.isFetchingSearchAccountLedgerReport,
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountLedger);
